import { createSlice } from '@reduxjs/toolkit';
import { addReplenishmentPoStyles, createReplenishmentPO, getReplenishmentEligiblePO, getReplenishmentOverallPO, getReplenishmentPO, getReplenishmentPOSummary } from './api';
import { getStoreConfig } from '../../apis';

export const ReplenishmentPoModelSlice = createSlice({

    name: 'replenishmentPoModelSlice',
    initialState: {
        loading: false,
        error: '',
        data: [],
        eligiblePoData: [],
        overallPoData: [],
        summaryData: [],
        stores: [],
        standardSizeSet: {},
        offlineInventoryConfigData: {},
        updateSuccess: false,
        createReplenishmentPOSuccess: '',
        addReplenishmentPoStylesSuccess: ''
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getStoreConfig.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getStoreConfig.fulfilled, (state, action) => {
            state.loading = false;
            state.stores = action.payload.data?.stores;
            state.standardSizeSet = action.payload.data?.standard_size_set;
            state.offlineInventoryConfigData = action.payload.data;
        })
        builder.addCase(getStoreConfig.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(getReplenishmentPO.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getReplenishmentPO.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data
        })
        builder.addCase(getReplenishmentPO.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
        builder.addCase(createReplenishmentPO.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createReplenishmentPO.fulfilled, (state, action) => {
            state.loading = false;
            state.createReplenishmentPOSuccess = true
        })
        builder.addCase(createReplenishmentPO.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(getReplenishmentEligiblePO.pending, (state, action) => {
            state.loading = true;
            state.eligiblePoData = [];
        })
        builder.addCase(getReplenishmentEligiblePO.fulfilled, (state, action) => {
            state.loading = false;
            state.eligiblePoData = action.payload.data;
        })
        builder.addCase(getReplenishmentEligiblePO.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getReplenishmentOverallPO.pending, (state, action) => {
            state.loading = true;
            state.overallPoData = [];
        })
        builder.addCase(getReplenishmentOverallPO.fulfilled, (state, action) => {
            state.loading = false;
            state.overallPoData = action.payload.data;
        })
        builder.addCase(getReplenishmentOverallPO.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getReplenishmentPOSummary.pending, (state, action) => {
            state.loading = true;
            state.summaryData = [];
        })
        builder.addCase(getReplenishmentPOSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.summaryData = action.payload.data;
        })
        builder.addCase(getReplenishmentPOSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(addReplenishmentPoStyles.pending, (state, action) => {
            state.loading = true;
            state.summaryData = [];
        })
        builder.addCase(addReplenishmentPoStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.addReplenishmentPoStylesSuccess = action.payload.data.message;
        })
        builder.addCase(addReplenishmentPoStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clearError, clear } = ReplenishmentPoModelSlice.actions

export default ReplenishmentPoModelSlice.reducer